import * as d3 from "d3";
import * as ss from "simple-statistics";

import { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import { GraphContext } from "../GraphContext";
import "../../styles.css";

import dayjs from 'dayjs';
import { saveAs } from 'file-saver';

import { preferences } from "../../preferences";

import { getCurrentYear, } from '../../js/datetime';

import ComboBox from '../../components/ComboBox';
import SensorComboBox from '../../components/SensorComboBox';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

import ExcelButton from '../../components/ExcelButton';
import GraphicButton from '../../components/GraphicButton';
import InfoButton from '../../components/InfoButton';

import DatePicker from '../../components/DatePicker';

import { borders, addLine, addArea } from '../../components/d3/legend/legend';
import { xlabel, ylabel, logo } from '../../components/d3/charts/chart';
import { timeformat, getWidth, responsivness } from '../../components/d3/d3timeformat';

import StationButton from "../../components/StationButton";
import StackRow from "../../components/StackRow";

import { useMatomo } from '@datapunt/matomo-tracker-react'
import Title from "../../components/Title";

export const Kenntage = ({ description, list }) => {


    const { trackPageView, trackEvent } = useMatomo()
    const location = useLocation();

    const { t, i18n } = useTranslation();
    const [parameter] = useContext(GraphContext);

    const [sensor, setSensor] = useState(1);
    const [sensorstring, setSensorstring] = useState(); // "airtemp2m"
    const [sensors, setSensors] = useState([]);

    const [data, setData] = useState();
    //const [variety, setVariety] = useState(1);

    const [combo1, setCombo1] = useState(1);
    const [combo2, setCombo2] = useState(5);

    const getWidth = () => window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    const [resize, setResize] = useState(getWidth());
    const resizeHandler = (() => {
        setResize(getWidth());
    });

    window.addEventListener('resize', resizeHandler);

    const svgRef = useRef();

    const Item = styled(Paper)(({ theme }) => ({

        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));

    useEffect(() => {

        let station = parameter.station;
        var url = preferences.address + '/rest/sensors.php?station=' + station;

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                data.map((sensor) => {
                    sensor.main = true;
                    sensor.min = false;
                    sensor.max = false;
                    return 0;
                })

                setSensors(data);
                setSensorstring("airtemp2m");
                setSensor(1);
            });
    }, [parameter])


    useEffect(() => {

        const svg = d3.select(svgRef.current);

        if (data !== undefined) {
            draw(svg);

            let r = responsivness();
            if (r.dialog) {
                let labels = [t("winter"), t("spring"), t("summer"), t("autumn")];
                borders(svg, labels, 300, 80, 20);
                let colors = ['#e41a1c', '#377eb8', '#4daf4a', "#0375948"];
                addArea(svg, 0, colors[0], labels[0]);
                addArea(svg, 1, colors[1], labels[1]);
                addArea(svg, 2, colors[2], labels[2]);
                addArea(svg, 3, colors[3], labels[3]);
            }
        }

    }, [resize, data, i18n.language]);

    useEffect(() => {

        d3.json(preferences.address + "/query/climate/temperature/kenntage/get.php?station=" + parameter.station + "&parameter=" + sensor)
            .then((data) => {
                setData(data);
            });
    }, [parameter, sensor, combo1, combo2, sensorstring]);


    // Track page view                                                                                                                           
    useEffect(() => {
        trackPageView({
            documentTitle: 'Phänologie Stadiumvergleich', // optional                                                                                             
            href: 'https://meteo.laimburg.it' + location.pathname, // optional                                                                         
            customDimensions: [
                {
                    id: 1,
                    value: 'loggedIn',
                },
            ], // optional                                                                                                                           
        })
    }, [trackPageView, location, i18n.language])


    const downloadExcel = () => {

        var url = preferences.address + '/query/climate/temperature/kenntage/excel.php';

        let block = {};
        block.station = parameter.station;
        block.sensor = sensor;
        block.lang = i18n.language;

        let filename = '';
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: "no-cache",
            headers: {
            },
            body: JSON.stringify(block)
        })
            .then((response) => {
                try {
                    filename = response.headers.get('content-disposition').split('filename=')[1];
                }
                catch (error) { filename = 'Data_Export.xlsx' }
                return response.blob()
            })
            .then((data) => {
                var file = new File([data], filename, { type: "application/vnd.ms-excel;charset=utf-8" });
                saveAs(file);
                trackEvent({
                    category: 'Downloads',
                    action: 'Excel',
                    name: filename, // optional
                    href: 'https://meteo.laimburg.it' + location.pathname, // optional	    
                })
            });

    }


    function rSquared(x, y, coefficients) {

        let regressionSquaredError = 0
        let totalSquaredError = 0

        function yPrediction(x, coefficients) {
            return coefficients[0] + coefficients[1] * x
        }

        let yMean = y.reduce((a, b) => a + b) / y.length

        for (let i = 0; i < x.length; i++) {
            regressionSquaredError += Math.pow(y[i] - yPrediction(x[i], coefficients), 2)
            totalSquaredError += Math.pow(y[i] - yMean, 2)
        }

        return 1 - (regressionSquaredError / totalSquaredError)

    }

    function draw(svg) {

        /*var ID_Time = {
            "dateTime": "%d %B %Y",
            "date": "%d.%m.%Y",
            "time": "%H:%M:%S",
            "periods": ["AM", "PM"],
            "days": [t("sunday"), t("monday"), t("tuesday"), t("wednesday"), t("thursday"), t("friday"), t("saturday")],
            "shortDays": [t("_sun"), t("_mon"), t("_tue"), t("_wed"), t("_thu"), t("_fri"), t("_sat")],
            "months": [t("january"), t("february"), t("march"), t("april"), t("may"), t("june"), t("july"), t("august"), t("september"), t("october"), t("november"), t("december")],
            "shortMonths": [t("_jan"), t("_feb"), t("_mar"), t("_apr"), t("_may"), t("_jun"), t("_jul"), t("_aug"), t("_sep"), t("_oct"), t("_nov"), t("_dec")]
        };
        d3.timeFormatDefaultLocale(ID_Time);*/
        timeformat (t);

        // Clear
        svg.selectAll("*").remove();

        const margin = {
            top: 20,
            right: 40,
            bottom: 40,
            left: 80,
        }; // margin of chart

        let width = parseInt(svg.style("width"));

        let min = d3.min(data.list.map((d) => { return d.year }));
        let max = d3.max(data.list.map((d) => { return d.year }));

        // Anzahl Jahre
        let height = 600;
        svg.attr("height", height);


        //Append group and insert axis

        let xScaleBand = d3.scaleBand()
            .domain(data.list.map((d) => d.year))
            .range([margin.left, width - margin.right])
            .padding(0.1);

        let xScaleBandRow = d3.scaleBand()
            .domain(data.list.map((d) => d.year))
            .range([margin.left, width - margin.right]);
        
        const fil = ((d, i) => {
            console.log(getWidth() / xScaleBand.domain().length);
            if (getWidth() / xScaleBand.domain().length < 10) {
                return i % 8 === 0;
            }

            if (getWidth() / xScaleBand.domain().length < 20) {
                return i % 4 === 0;
            }

            if (getWidth() / xScaleBand.domain().length < 40)
                return i % 2 === 0;

            return true;
        })




        let xAxis = d3.axisBottom(xScaleBand)
            .tickValues(xScaleBand.domain().filter(fil));

        svg.append("g")
            .attr("transform", `translate(0, ${height - margin.bottom})`)
            .call(xAxis.tickFormat((x) => { return x }).ticks(20));
        //let xAxisBand = d3.axisBottom(xScaleBand);

        // X Axis
        let xScale = d3.scaleLinear()
            .domain([min, max])
            .range([margin.left + xScaleBandRow.bandwidth() / 2, width - margin.right - xScaleBandRow.bandwidth() / 2]);
        /*let xAxis = d3.axisBottom(xScale);
        svg.append("g")
            .attr("transform", `translate(0, ${height - margin.bottom})`)
            .call(xAxis.tickFormat((x) => { return x }).ticks(20));
        svg.append("g")
            .attr("class", "gridline")
            .attr("transform", `translate(0, ${height - margin.bottom})`)
            .call(xAxis.tickSize(-height + margin.top + margin.bottom, 0).tickFormat("").ticks(20));*/

        // Y Axis
        var yScale = d3.scaleLinear()
            .domain([0, d3.max([10, d3.max(data.list.map((d) => { return d.days }))])])
            .range([height - margin.bottom, margin.top]);
        let yAxis = d3.axisLeft(yScale);
        svg.append("g")
            .attr("transform", `translate(${margin.left}, 0)`)
            .call(yAxis.tickFormat((x) => { return x + " " + t("days") }))
        //let yGrid =
        svg.append("g")
            .attr("transform", `translate(${margin.left}, 0)`)
            .attr("class", "gridline")
            .call(yAxis.tickSize(-width + margin.left + margin.right, 0).tickFormat("").ticks(20));

        let clip = svg.append('g')
            .attr("clip-path", "url(#clip)");


        // Add the circles
        /*svg.selectAll("circles")
            .data(data.list)
            .enter()
            .append("circle")
            .attr("fill", "white")
            .attr("stroke", "black")
            .attr("cx", (d, i) => { return xScale(d.year) })
            .attr("cy", (d) => { return yScale(d.days) })
            .attr("r", 3)
            .attr("stroke-width", 2.5)
            .attr('display', (d) => { return d.days === null ? 'none' : '' })
            .append("title")
            .text((d) => { return d.year });*/

        /*clip.selectAll(".bar")
        .data(data.list)
        .enter()
            .append("rect")
        .attr("class", "bar")
            .style("pointer-events", "none")
        .attr("x", function (d) { return xScaleBand(d.year) })
            .attr("y", (d) => { return yScale(d.days) + height - margin.bottom - yScale(0) })
        .attr("width", (d) => { return xScaleBand.bandwidth()})
            .attr("height", (d) => { return yScale(0) - yScale(d.days) })
            .attr("stroke", "black")
            .attr("stroke-width", 1.5)
        .attr("opacity", 0.75)
            .attr('fill', d3.schemeCategory10[sensor]);
    */
        /*d3.csv("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/data_stacked.csv", function(data) {
            //var subgroups = data.columns.slice(1);
            console.log (data.columns);
        })*/

        // color palette = one color per subgroup
        let keys = ["winter", "spring", "summer", "autumn"];
        var colors = d3.scaleOrdinal()
            .domain(keys)
            .range(['#e41a1c', '#377eb8', '#4daf4a', "#0375948"])

        /*var dataset = d3.stack()(keys.map(function(s) {
            return data.stack.map(function(d) {
            return {x: d3.format("%Y").parse(d.year), y: +d[s]};
            });
        }));*/
        var stackedData = d3.stack()
            .keys(keys)
            (data.stack)
        // Doppelarray: Kategorie (Jahreszeit), Jahr

        // Show the bars
        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = group per group
            .data(stackedData)
            .enter().append("g")
            .attr("fill", function (d) { return colors(d.key); })
            .selectAll("rect")
            // enter a second time = loop subgroup per subgroup to add all rectangles
            .data(function (d) { return d; })
            .enter().append("rect")
            .attr("x", function (d, i) { return xScaleBand(data.stack[i].year); })
            .attr("y", function (d) { return yScale(d[1]); })
            .attr("height", function (d) { return yScale(d[0]) - yScale(d[1]); })
            .attr("width", xScaleBand.bandwidth())
            .append("title")
            .text((d) => d[1] - d[0])


        /*var groups = svg.selectAll("g.bars")
            .data(data.stack)
            .enter().append("g")
            .attr("class", "bars")
            .style("fill", function(d, i) { return colors[i]; })
            .style("stroke", "#000");
    
        var rect = groups.selectAll("rect")
            .data(function(d) { return d; })
            .enter()
            .append("rect")
            .attr("x", function(d) { return xScale(d.x); })
            .attr("y", function(d) { return yScale(d.y0 + d.y); })
            .attr("height", function(d) { return yScale(d.y0) - yScale(d.y0 + d.y); })
            .attr("width", xScale.rangeBand())
    */

        /*.attr("x", function (d) { return xScaleBand(d.year) })
            .attr("y", (d) => { return yScale(d.days[0]) + height - margin.bottom - yScale(0) })
        .attr("width", (d) => { return xScaleBand.bandwidth()})
            .attr("height", (d) => { return yScale(0) - yScale(d.days[0]) })
            .attr("stroke", "black")
            .attr("stroke-width", 1.5)
        .attr("opacity", 0.75)
            .attr('fill', d3.schemeCategory10[sensor]);*/

        /*.enter().append("g")
        .attr("fill", function(d, i) { return color(i); })
        .selectAll("rect")
    // enter a second time = loop subgroup per subgroup to add all rectangles
        .data(function(d) { return d.days; })
        .enter().append("rect")
            .attr("x", function(d) { return xScaleBand(d.year); })
            .attr("y", function(d) { return yScale(d.days[1]); })
            .attr("height", function(d) { return yScale(d.days[0]) - yScale(d.days[1]); })
            .attr("width", xScaleBand.bandwidth())
        */

        // Beschriftung
        if (xScaleBand.bandwidth() > 25) {
            let labels = svg.append("g");
            labels.selectAll(".bar")
                .data(data.list)
                .enter()
                .append("rect")
                .attr("class", "bar")
                .attr("x", function (d) { return xScaleBand(d.year) })
                .attr("y", (d) => { return yScale(d.days > 0 ? d.days : 0) - 20 }) //+ height - margin.bottom - yScale(0)
                .attr("width", (d) => { return xScaleBand.bandwidth() })
                .attr("height", 20)
                .attr("stroke", "black")
                .attr("stroke-width", 1.5)
                .attr('fill', "white")
                .attr("opacity", 0.80)
                .attr("rx", 5).attr("ry", 5)
                .attr("display", (d) => { return d.days > 0 ? "" : "none" });

            labels.selectAll(".label")
                .data(data.list)
                .enter()
                .append("text")
                .attr("class", "label")
                .attr("x", function (d) { return xScaleBand(d.year) + xScaleBand.bandwidth() / 2 })
                .attr("y", (d) => { return yScale(d.days > 0 ? d.days : 0) + 10 - 15 })
                .text((d) => Math.round(d.days * 10) / 10)
                .attr("display", (d) => { return d.days > 0 ? "" : "none" });
        }


        let learn = [];
        let year = new Date().getFullYear();
        let fList = data.list.filter((d) => { return d.year < year })
        fList.map((d) => { if (d.days !== null) learn.push([d.year, d.days]); return 0; })
        const reg = ss.linearRegression(learn);
        let lm = ss.linearRegressionLine(reg);


        clip.append("path")
            .datum(fList)
            .attr("fill", "none")
            .attr("stroke", "black")
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x(function (d, i) { return xScale(d.year) })
                .y(function (d) { return yScale(lm(d.year)) })
            )

        let x = fList.map((d) => { return d.year });
        let y = fList.map((d) => { return d.days });

        try {
            let r = rSquared(x, y, [reg.b, reg.m]);
            //console.log(r);
            xlabel(svg, "y=" + Math.round(reg.m * 100000) / 100000 + "*x +(" + Math.round(reg.b * 1000) / 1000 + ")", width / 3, 15);
            xlabel(svg, "R²=" + Math.round(r * 1000) / 10 + "%", width * 2 / 3, 15);
        } catch (error) { console.log(error) };

        xlabel(svg, t("years"), width / 2, height - 5);
        //ylabel(svg, t("days"), -height * 0.5, 15);
        logo(svg);

        //bordersH (svg, ["", ""], 260, 70, 0);
        //addAreaH (svg, 0, "orange", t("dry"))

        //let colors = ['rgba(255,255,255,1)', '#084594', '#000000'];
        //label_mid (svg, colors, 0, 20, 80, "mm", width - 50, 30);

        //addAreaH (svg, 1, "#084594", t("rain"))

    }

    /*const excelDownloadCallback = () =>
    {

        d3.json(preferences.address + "/query/climate/dry_excel.php?station=" + parameter.station + "&period=" + period + "&level=" + threshold)
            .then((data) => {
                var file = new File([data], "Export.xlsx", { type: "application/vnd.ms-excel;charset=utf-8" });
                saveAs(file);
            });

    }*/

    const handleSelector = (event) => {
        setSensor(event.target.value);
    };

    return (
        <>
            <div className="stagearea grid">

                <Stack spacing={0}>

                    <Item>
                        <ComboBox
                            title={t("days")}
                            value={sensor} items={[t("rainday"), t("iceday"), t("frostday"), t("summerday"), t("tropicday"), t("desertday"), t("tropicnight")]}
                            callback={handleSelector} />
                    </Item>

                </Stack>

                <div id="svgchart">
                    <svg ref={svgRef} id="svg_chart" className="d3chart"></svg>
                </div>

                <Grid container flexDirection={"row"}>

                    <Grid item className="p-2" flexGrow={1}>
                        <InfoButton
                            de={"<p>Im Bereich “meteorologische Kenntage” kann die Anzahl der Kenntage pro Jahr angezeigt werden. Die Balkendiagramme sind gestapelt, das bedeutet, dass die Balken in die 4 Jahreszeiten Winter, Frühjahr, Sommer und Herbst eingeteilt sind.</p> <p>Die Werte der Monate März, April, Mai werden zum Frühjahr aufsummiert, die Monate Juni, Juli und August zum Sommer, die Monate September, Oktober und November zum Herbst und die Monate Dezember des vorherigen Jahres mit den Monaten Jänner und Februar zum Winter. Mittels Mausklick auf das entsprechende Feld können die Werte direkt in der Grafik angezeigt werden.</p> <p>Der darzustellende Kenntag kann aus der Drop-down-Liste oben rechts ausgewählt werden. In der nachstehenden Tabelle ist die Definition der auswählbaren Kenngrößen aufgelistet:</p> <p><strong>Regentag</strong> = Tag mit mindestens 0,1 mm Niederschlag (≥0,1 mm) </p> <p><strong>Frosttag</strong> = Tagestiefsttemperatur unter Null Grad C (Tmin < 0 °C) </p> <p> <strong>Eistag</strong> = Tageshöchsttemperatur unter Null Grad C (Tmax < 0 °C) </p> <p> <strong>Sommertag</strong> = Tageshöchsttemperatur mindestens 25 Grad C (Tmax ≥ 25 °C) </p> <p> <strong>Tropentag</strong> = Tageshöchsttemperatur mindestens 30 Grad C, auch als Hitzetag bezeichnet (Tmax ≥ 30 °C) </p> <p> <strong>Wüstentag</strong> = Tageshöchsttemperatur mindestens 35 Grad C, wird auch als extrem heißer Tag bezeichet (Tmax ≥ 35 °C) </p> <p> <strong>Tropennacht</strong> Nächtliche Tiefsttemperatur zwischen 18 und 6 Uhr fällt nicht unter 20 Grad C (Tnight ≥ 20 °C) </p>"}
                            it={"<p>L'area degli indici climatici di riferimento è suddivisa in tre schede: numero di giorni per stagione, giorni con indici climatici dipendenti della temperatura e giorni climatici di riferimento della pioggia e insolazione.</p><p>Nell'area 'indici climatici' è possibile visualizzare il numero di giorni climatici per stagione e anno. I grafici a barre sono sovrapposti, il che significa che le barre sono suddivise nelle 4 stagioni inverno (rosso), primavera (blu), estate (verde) e autunno (nero). I valori dei mesi di marzo, aprile e maggio vengono sommati alla primavera, i mesi di giugno, luglio e agosto all'estate, i mesi di settembre, ottobre e novembre all'autunno e i mesi di dicembre dell'anno precedente con i mesi di gennaio e febbraio all'inverno. Tramite un clic del mouse sul campo corrispondente, i valori saranno visualizzati direttamente nel grafico. Il giorno da visualizzare può essere selezionato dal menu a tendina in alto a destra. Nella tabella seguente viene elencata la definizione dei parametri selezionabili:</p> <p><strong>Giorno di pioggia</strong> = giorno con almeno 0,1 mm di precipitazioni (≥0,1 mm) </p>  <p><strong>Giorno di gelo</strong> = temperatura minima giornaliera inferiore a zero gradi C (Tmin < 0 °C)</p> <p><strong>Giorno di ghiaccio</strong> = temperatura massima giornaliera inferiore a zero gradi C (Tmax < 0 °C)</p> <p><strong>Giorno estivo</strong> = temperatura massima giornaliera di almeno 25 gradi C (Tmax ≥ 25 °C)</p> <p><strong>Giorno tropicale</strong> = temperatura massima giornaliera di almeno 30 gradi C, nota anche come giorno caldo (Tmax ≥ 30 °C)</p> <p><strong>Giorno desertico</strong> = temperatura massima giornaliera di almeno 35 gradi C, detto anche giorno estremamente caldo (Tmax ≥ 35 °C)</p> <p><strong>Notte tropicale</strong> = la temperatura minima notturna tra le 18.00 e le 6.00 non scende al di sotto dei 20 gradi C (Tnight ≥ 20 °C)</p>"}
                            en={"<p>The area of the climatological indices is divided into three tabs: climatological indices per season, temperature as well as rainy days and sunshine duration.</p><p>The “Climatological indices” section shows the number of days of the four different seasons. The bar charts are stacked, which means that the bars are divided into the 4 seasons winter (red), spring (blue), summer (green) and fall (black). The values of the months March, April and May are added up to spring, the months June, July and August to summer, the months September, October and November to autumn and the months December of the previous year with the months January and February to winter. The values can be displayed by clicking on the corresponding field directly in the diagram.</p><p>The climatological indices can be selected from the drop-down list at the top right. The table below shows the definition of the selectable indices:</p><p><strong>Rain days</strong> = days with at least 0,1 mm precipitation (≥0,1 mm)</p><p><strong>Frost days</strong> = minimum temperature of the day is lower than zero degrees centigrade (Tmin < 0 °C)</p><p><strong>Ice days</strong> = maximum temperature of the day is lower than zero degrees centigrade (Tmax < 0 °C)</p><p><strong>Summer day</strong> = temperatura massima giornaliera di almeno 25 gradi C (Tmax ≥ 25 °C)</p><p><strong>Hot day</strong> = also known as hot day with daily maximum temperature of at least 30 degrees C (Tmax ≥ 30 °C)</p><p><strong>Desert days</strong> = Daily maximum temperature of at least 35 degrees C, also called an extremely hot day (Tmax ≥ 35 °C)</p><p><strong>Tropical night</strong> = the minimum nighttime temperature between 6 p.m. and 6 a.m. does not fall below 20 degrees C (Tnight ≥ 20 °C)</p><p>Summer days, hot days and desert days, as well as tropical nights are the climatological indices which are displayed in this section. The course of the selected year is shown as a line. The boxplot per month shows the distribution of the values of the previous 30 years. The bar chart below the box plot indicates the deviation of the current year from the long-term median value. The exact deviation can be displayed directly in the graph by clicking on the corresponding bar.</p>"}
                        />
                    </Grid>

                    <Grid item>
                        <GraphicButton object="svg_chart" filename={t("dry")} />
                    </Grid>

                    <Grid item className="p-2">
                        <ExcelButton callback={downloadExcel} />
                    </Grid>

                </Grid>
            </div>
        </>
    );

}
